import React,  { Component } from 'react'
import PropTypes from 'prop-types'
import AppPlaceholder from '../AppPlaceholder'
import { withRouter } from 'react-router-dom'
import { defaultTo } from 'ramda'
import defaultIconSrc from './defaultIcon.svg'
import { Button } from '@driftt/tide-core'
import ConditionalRender from 'components/ConditionalRender'
import DeleteAppModal from './DeleteAppModal'
import './style.css'

const providedOrDefaultIcon = (iconUrl) => defaultTo(defaultIconSrc)(iconUrl);


class AppsPageAppSection extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    descirption: PropTypes.string,
    iconUrl: PropTypes.string,
    showErrorNotification: PropTypes.func.isRequired,
    onAppDeleted: PropTypes.func.isRequired
  }

  state = {
    secondaryButtonsVisible: false,
    isDeleteModalVisible: false
  }

  showSecondaryButtons = () => {
    this.setState({ secondaryButtonsVisible: true })
  }

  hideSecondaryButtons = () => {
    this.setState({ secondaryButtonsVisible: false })
  }

  openDeleteModal = () => {
    this.setState({ isDeleteModalVisible: true })
  }

  closeDeleteModal = () => {
    this.setState({ isDeleteModalVisible: false })
  }

  onAppDeleted = () => {
    this.props.onAppDeleted()
  }

  render() {
    const { history, id, name, description, iconUrl, showErrorNotification, onAppDeleted } = this.props
    const { secondaryButtonsVisible, isDeleteModalVisible } = this.state

    return (
      <AppPlaceholder>
        <div
          className="apps-page-app-section"
          onMouseEnter={this.showSecondaryButtons}
          onMouseLeave={this.hideSecondaryButtons}
          onBlur={this.hideSecondaryButtons}>
          <img
            className="apps-page-app-section-icon"
            src={providedOrDefaultIcon(iconUrl)}
            alt="app icon"
          />
          <span className="apps-page-app-section-name">
            {name}
          </span>
          <p className="apps-page-app-section-description">
            {description}
          </p>
          <ConditionalRender
            condition={secondaryButtonsVisible}
            className="apps-page-app-section-buttons">
            <Button
              type="primary"
              className="apps-page-app-manage"
              onClick={() => history.push(`/app/${id}`)}
            >
              Manage
            </Button>
            <Button
              type="secondary"
              className="apps-page-app-delete"
              onClick={this.openDeleteModal}>
              Delete
            </Button>
          </ConditionalRender>
          <ConditionalRender condition={isDeleteModalVisible}>
            <DeleteAppModal
              onCloseInitiated={this.closeDeleteModal}
              appName={name}
              appId={id}
              showErrorNotification={showErrorNotification}
              onAppDeleted={onAppDeleted}
            />
          </ConditionalRender>
        </div>
      </AppPlaceholder>
    )
  }
}

export default withRouter(AppsPageAppSection)
